export const EMPLOYEES_TYPE = {
  seller: 'seller',
  rd: 'rd',
  worker: 'worker',
  super_worker: 'super-worker',
  storage_worker: 'storage-worker',
  admin: 'admin',
  ceo: 'ceo'
}

export const GENDERS = {
  guy: 'guy',
  girl: 'girl'
}
